import React from 'react';

const SearchBox = ({
  styleName,
  placeholder,
  onChange,
  onKeyPress,
  value,
  onKeyUp,
}: any) => {
  return (
    <div className={`gx-search-bar ${styleName}`}>
      <div className="gx-form-group">
        <input
          className="ant-input"
          type="search"
          placeholder={placeholder}
          onChange={onChange}
          onKeyPress={onKeyPress}
          value={value}
          onKeyUp={onKeyUp}
        />
        <span className="gx-search-icon gx-pointer">
          <i className="icon icon-search-new" />
        </span>
      </div>
    </div>
  );
};

export default SearchBox;

SearchBox.defaultProps = {
  styleName: '',
  value: '',
};
